/** Ekran bileşenleri için "Paylaş": ızgaranın durumunu alır, paylaşım penceresini açar. */
import { useState } from 'react';
import type { TabModel } from '@/features/shell/tabs/tabsStore';
import { tabLabel } from '@/features/shell/tabs/tabsStore';
import { decodeShareState, type GridShareState } from '@/features/grid/model/shareState';
import { ShareScreenDialog } from '../ui/ShareScreenDialog';

export function useScreenShare(tab: TabModel) {
  const [req, setReq] = useState<{ state: GridShareState; summary: { filters: number; search: string; rows: number } } | null>(null);
  const shared = tab.params['shared'];
  const sharedState = typeof shared === 'string' ? decodeShareState(shared) : null;
  return {
    /** Paylaşılan bağlantıyla açıldıysa ızgaraya uygulanacak durum. */
    sharedState,
    onShare: tab.screenId
      ? (state: GridShareState, summary: { filters: number; search: string; rows: number }) => setReq({ state, summary })
      : undefined,
    dialog:
      req && tab.screenId ? (
        <ShareScreenDialog screenId={tab.screenId} caption={tabLabel(tab)} state={req.state} summary={req.summary} onClose={() => setReq(null)} />
      ) : null,
  };
}
